export const RESCHEDULE_STEP_NUMBER = {
  TIME: 1,
  DETAILS: 2,
  CONFIRM: 3,
  DONE: 4,
};

export const RESCHEDULE_STEPS = [
  { key: 'time', title: 'New time' },
  { key: 'details', title: 'Your details' },
  { key: 'confirm', title: 'Confirm' },
];

// Shown before the step counter, as booking shows "New booking · 1 of 4".
export const RESCHEDULE_COUNTER_PREFIX = 'Reschedule';

export const PAYMENT_STATE_LABEL = {
  paid: 'Paid',
  unpaid: 'Not paid yet',
  manual: 'Arranged with our team',
  none: 'Nothing to pay now',
};
